module.exports = __webpack_public_path__ + "images/7f60fc7bf693ca22c901a7ac2e67ad56-illu_dir_water1.png";